import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-duplicate-candidate',
  templateUrl: './duplicate-candidate.component.html',
  styleUrls: ['./duplicate-candidate.component.css']
})
export class DuplicateCandidateComponent implements OnInit {
  @Input() display: boolean;
  @Output() displayFunction = new EventEmitter<boolean>();
  @Input() phone: string;
  @Input() email: string;
  
  applicants: any;
  showInterviewTable: boolean= false;
  isFetchingRecords : boolean = true;
  columns = [
    { field: 'dateTime', header: 'Date & Time', type: 'date',width:"7%"},
    { field: 'candidateName', header: 'Candidate Name',width:"7%"},
    { field: 'mobile', header: 'Mobile No.', width:"7%"},
    { field: 'email', header: 'Email Id', width:"12%"},
    { field: 'jobDescriptionName', header: 'Jd Name' ,width:"10%"},
    { field: 'primaryRecruiter', header: 'Primary Recruiter', width:"7%"},
    { field:'interviewStatus', header:'Status' , width:"7%" }
  ];
  constructor( private http: HttpClient) {}

  ngOnInit() {
    console.warn(this.display);
    console.warn(this.phone);
    console.warn(this.email);
    this.candidateDuplicateData();
  }
  // ngOnChanges(){
  //   console.warn(this.phone);
  //   console.warn(this.email);
  //   console.warn(this.display);
  //   this.candidateDuplicateData();
  // }

  showDialog1() {
   this.displayFunction.emit(false);
  }
  candidateDuplicateData(){
    if(!this.phone || !this.email){
    return ;
  }
  let duplicate = {
    phone : this.phone,
    email : this.email
    }
    console.log(duplicate);
    this.http.post(environment.apiUrl+"/interview/duplicate-candidate-data",duplicate).subscribe(res=>{
      this.isFetchingRecords = false;
      this.applicants=res;
      console.log(this.applicants);
      if(this.applicants.length>0){
        this.showInterviewTable=true;
        for(let i=0;i< this.applicants.length;i++){
          this.applicants[i]['dateTime']=this.applicants[i].interviewDate;
          this.applicants[i]['candidateName']=this.applicants[i].candidateName;
          this.applicants[i]['mobile']=this.transformPhoneNumber(this.applicants[i].phone);
          this.applicants[i]['email']=this.applicants[i].email;
          this.applicants[i]['primaryRecruiter']=this.applicants[i].primaryRecruiterName?this.applicants[i].primaryRecruiterName: '';
          this.applicants[i]['jobDescriptionName']=this.applicants[i].jobDescriptionName?this.applicants[i].jobDescriptionName + " "+this.applicants[i].specialAttribute : '';
          this.applicants[i]['interviewStatus']=this.applicants[i].interviewStatus
        }
      }
      else{
        this.showInterviewTable=false;
      }
  });
  }
  transformPhoneNumber(phone:string) {
    if(phone){
    const areaCodeStr = phone.slice(0,3);
    const midSectionStr = phone.slice(3,6);
    const lastSectionStr = phone.slice(6);

    return `${areaCodeStr}-${midSectionStr}-${lastSectionStr}`;
    }
    else{
      return "";
    }
  }

  goToCandidateSearch(data){
    let obj :any = {     
      "id": data.candidateId,
      "email":data.email,
      "fullName": data.candidateName,
      "name": data.candidateName + ' - ' + data.mobile,
      "phone":data.phone,
      "firstName": "",
      "lastName":""
    };
    localStorage.setItem("candidateData", JSON.stringify(obj));
    return;
    
  }
  

  // closeDialog(){
  // this.display=false;
  // this.displayFunction.emit(false);
  // }
}
